export default __webpack_public_path__ + "static/univers-rounded-light-1e282d892f45425d99a09143251cac44.woff2";